export const isInPreview = () => new URLSearchParams(window.location.search).get('preview') === 'true';